"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_report_card_controller_1 = __importDefault(require("./student-report-card.controller"));
var student_report_card_html_1 = __importDefault(require("./student-report-card.html"));
function getReportcard(UsersModel, UserService) {
    var user = UserService.getCurrentUser();
    return UsersModel.getStudentReportcards({ id: user.id }).then(function (response) {
        return response;
    });
}
getReportcard.$inject = ["UsersModel", "UserService"];
function getStudent(UserService) {
    return UserService.getCurrentUser();
}
getStudent.$inject = ["UserService"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.dashboard.reportcard", {
        url: "/report-card",
        controller: student_report_card_controller_1.default,
        controllerAs: "vm",
        template: student_report_card_html_1.default,
        resolve: {
            reportData: getReportcard,
            user: getStudent,
        },
        data: {
            authorizedRoles: [USER_ROLES.admin, USER_ROLES.owner, USER_ROLES.student],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.dashboard.reportcard", [])
    .config(config)
    .controller("StudentReportCardController", student_report_card_controller_1.default);
